import React from 'react';
import { connect, type ConnectedProps } from 'react-redux';
import RouteActions from 'app/shared/flux/actions/RouteActions';
import UserSearchActions from 'app/shared/flux/actions/UserSearchActions';
import gmapUtils, { type IMap } from 'app/client/utils/map/gmapUtils';
import type MapData from 'app/shared/models/MapData';
import type { ThunkDispatch } from 'redux-thunk';
import type { Action } from 'redux';
import IconPlus from 'images/icons/plus.svg';
import './style.scss';

type MapDataWithBorder = MapData & { border?: boolean };

const connector = connect();

type PropsFromRedux = ConnectedProps<typeof connector>;

type WidenSearchButtonProps = PropsFromRedux & {
  area: {
    name: string;
  };
};

class WidenSearchButton extends React.Component<WidenSearchButtonProps> {
  handleWidenSearch = () => {
    const { dispatch } = this.props;
    const map = window.map as IMap | undefined;
    if (!map) {
      return;
    }
    const mapData = gmapUtils.getMapData(map) as MapDataWithBorder;
    mapData.border = false;
    const thunkDispatch = dispatch as ThunkDispatch<unknown, unknown, Action>;
    thunkDispatch(RouteActions.updateUrlWithMapData(mapData));
    thunkDispatch(
      UserSearchActions.setCurrentSearch({
        mapData,
        waiting: undefined,
        resourceId: undefined,
      }),
    );
  };

  render() {
    return (
      <div onClick={this.handleWidenSearch} className="WidenSearchButton">
        <span className="WidenSearchButton-plus-icon">
          <img src={IconPlus} height="12" width="12" />
        </span>
        <span className="WidenSearchButton-text">
          Widen search outside of <b>{this.props.area.name}</b>
        </span>
      </div>
    );
  }
}

export default connector(WidenSearchButton);
